import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxTinySliderModule } from 'ngx-tiny-slider';

import { CatalogoRoutingModule } from './catalogo-routing.module';
import { CatalogoComponent } from './catalogo.component';
import { HomeComponent } from './pages/home/home.component';
import { ListComponent } from './pages/list/list.component';
import { PromocaoComponent } from './pages/promocao/promocao.component';
import { OutletComponent } from './pages/outlet/outlet.component';
import { FavoritosComponent } from './pages/favoritos/favoritos.component';
import { DetailComponent } from './pages/detail/detail.component';

import { FavoritosService } from './services/favoritos.service';
import { MaterialCardComponent } from './components/material-card/material-card.component';
import { MaterialListComponent } from './components/material-list/material-list.component';
import { PromoListComponent } from './components/promo-list/promo-list.component';
import { NavButtonsComponent } from './components/nav-buttons/nav-buttons.component';
import { FilterComponent } from './components/filter/filter.component';
import { SearchComponent } from './components/search/search.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { InitialCapsPipe } from './pipe/initial-caps.pipe';
import { CapitalizePipe } from './pipe/capitalize.pipe';

@NgModule({
  declarations: [
    CatalogoComponent,
    HomeComponent,
    ListComponent,
    PromocaoComponent,
    OutletComponent,
    FavoritosComponent,
    DetailComponent,
    MaterialCardComponent,
    MaterialListComponent,
    PromoListComponent,
    NavButtonsComponent,
    FilterComponent,
    SearchComponent,
    InitialCapsPipe,
    CapitalizePipe,
  ],
  imports: [
    CommonModule,
    NgxTinySliderModule,
    CatalogoRoutingModule,
    NgbModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule
  ],
  exports: [
    NgxTinySliderModule
  ],
  providers: [
    FavoritosService
  ]
})
export class CatalogoModule { }
